export function visibleFirstName(name: string | null | undefined): string {
  const firstName = name?.trim().split(/\s+/)[0] ?? ''
  if (!firstName) return ''
  if (firstName.toLowerCase() === 'convidado') return ''
  if (/^student\d+$/i.test(firstName)) return ''
  return firstName
}
